import React from 'react';

const BiographySection = () => {
  return (
    <section className="py-16 bg-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Headshot Image */}
          <div className="flex justify-center lg:justify-end">
            <div className="rounded-xl overflow-hidden shadow-xl border-2 border-accent/30 w-full max-w-md">
              <img 
                src="/images/brad-wilde-headshot.png" 
                alt="Brad Wilde - Founder of Eluno Consulting" 
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
          
          {/* Biography Content */}
          <div className="lg:pr-8">
            <h2 className="text-3xl sm:text-4xl font-bold text-light mb-6">
              Meet <span className="text-accent">Brad Wilde</span>
            </h2>
            <div className="text-light/80 text-lg space-y-6">
              <p className="leading-relaxed">
                I'm Brad Wilde, a strategic advisor and technology consultant with over 25 years of experience guiding organizations through complex challenges in AI, digital transformation, healthcare technology, and strategic initiatives. I founded Eluno Consulting to partner closely with business leaders and entrepreneurs, delivering tailored solutions that drive meaningful innovation, operational efficiency, and sustained growth.
              </p>
              <div className="pt-4">
                <a 
                  href="https://www.linkedin.com/in/bwilde" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="inline-flex items-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-dark bg-accent hover:bg-accent/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent transition duration-150"
                >
                  <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                  </svg>
                  Connect on LinkedIn
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BiographySection;